import React from 'react';
import {ContentTemplate, TitleHeader} from 'web-library';
import {useTranslation} from 'react-i18next';
import AdminProfileDetails from '../../modules/profile/components/AdminProfileDetails';


const AdminProfileDetail = () => {
  const {t} = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>CreateOpsAdminForm.My Profile')} />

      <ContentTemplate>
        <AdminProfileDetails />
      </ContentTemplate>
    </>
  );
};

export default AdminProfileDetail;
